import { CourseInfo } from '../../types/apis/contentsListApi';

/**
 * トレーニングのモード一覧
 */
export const TRAINING_MODE = {
  HOP: 'Hop',
  SKIP: 'Skip',
  JUMP: 'Jump',
} as const;

type TRAINING_MODE = typeof TRAINING_MODE[keyof typeof TRAINING_MODE];

/**
 * 次のトレーニングIDを返す
 * @param contents トレーニングのコンテンツリスト
 * @param currentTrainingId 現在のトレーニングID
 * @returns 次のトレーニングID
 */
const nextTrainingId = (
  contents: CourseInfo[],
  currentTrainingId: number,
): number => {
  if (contents == null || contents.length === 0) {
    return -1;
  }
  // 念の為、小数を切り捨てる
  let nextId = Math.floor(currentTrainingId + 1);
  const lastTrainingId = contents[contents.length - 1].jumpId;
  const firstTraingId = contents[0].hopId;

  // 範囲外なら、最初のIDを返す
  if (nextId < firstTraingId || lastTrainingId < nextId) {
    nextId = firstTraingId;
  }

  return nextId;
};

/**
 * トレーニングモードの文字列
 * @param trainingId トレーニングID
 * @returns トレーニングモーdの文字列
 */
const trainingMode = (trainingId: number): string => {
  if (trainingId % 3 === 1) {
    return TRAINING_MODE.HOP;
  }

  if (trainingId % 3 === 2) {
    return TRAINING_MODE.SKIP;
  }

  return TRAINING_MODE.JUMP;
};

export { nextTrainingId, trainingMode };
